import React from 'react';

import {
	Box,
	Container,
	Typography,
	Grid,
	Card,
	CardContent
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import VideoBackground from '../../../../components/VideoBackground';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckIcon from '@mui/icons-material/Check';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const LandingPage = () => {
	const { t } = useTranslation('landing', {
		keyPrefix: 'sections.featureShowcase'
	});
	// Feature data
	const features = [
		{
			icon: <AutoAwesomeIcon fontSize="large" />,
			title: t('semantic.header'),
			desc: t('semantic.description')
		},
		{
			icon: <CloudUploadIcon fontSize="large" />,
			title: 'Instant Share',
			desc: 'Create secure links in seconds. No YouTube upload required.'
		},
		{
			icon: <CheckIcon fontSize="large" />,
			title: 'Smart Archive',
			desc: 'Drag-and-drop uploads. Automatic thumbnail generation for quick browsing.'
		}
	];

	return (
		<Box
			id="features"
			component="section"
			sx={{
				py: 5
				// bgcolor: 'background.paper'
			}}
		>
			<VideoBackground>
				<Container maxWidth="lg">
					<Typography
						variant="h4"
						align="center"
						gutterBottom
						fontWeight="bold"
					>
						{t('header')}
					</Typography>

					<Grid container spacing={2} justifyContent="center">
						{features.map((feature, index) => (
							<Grid key={index}>
								<Card
									sx={{
										p: 2,
										height: '100%',
										borderRadius: 3,
										border: '1px solid',
										borderColor: 'text.primary'
									}}
								>
									<CardContent>
										<Box sx={{ color: '#2196f3', mb: 2 }}>{feature.icon}</Box>
										<Typography variant="h6">{feature.title}</Typography>
										<Typography variant="body2" color="textSecondary">
											{feature.desc}
										</Typography>
									</CardContent>
								</Card>
							</Grid>
						))}
					</Grid>
				</Container>
			</VideoBackground>
		</Box>
	);
};

export default LandingPage;
